namespace Matrix.Data {
    export interface RelationshipTypeForm {
        RelationshipTypeCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        RelationshipGroup: Serenity.StringEditor;
        Status: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class RelationshipTypeForm extends Serenity.PrefixedContext {
        static formKey = 'Data.RelationshipType';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!RelationshipTypeForm.init)  {
                RelationshipTypeForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(RelationshipTypeForm, [
                    'RelationshipTypeCode', w0,
                    'Name', w0,
                    'RelationshipGroup', w0,
                    'Status', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
